var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"high-risk-badge",class:_vm.count > 0 ? 'high-risk-badge--danger' : 'high-risk-badge--none'},[_vm._v(" "+_vm._s(_vm.count)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }